import { produce } from 'immer';
import type { ApiActionType } from 'app/store/utils';
import { GET_PUBLIC_CONFIG } from 'app/store/applicationConfig/types.js';
import { LOAD_ATTRIBUTE_DEFINITIONS } from 'app/store/attributes/types.js';
import { LOAD_GLOSSARY } from 'app/store/glossary/types.js';
import { LOAD_PROJECTS } from 'app/store/projects/types.js';
import {
    GET_ACCEPT_TERMS,
    LIST_USER_DETAILS,
    KEYCLOAK_CONNECTION_ERROR
} from 'app/store/users/types.js';

export type StartupSlice = {
    initEvents: Record<typeof ApiActionType.prototype.ENDED, boolean>;
    error: null | Record<string, string>;
};
export const INITIAL_STATE: StartupSlice = {
    initEvents: {
        [GET_PUBLIC_CONFIG.ENDED]: false,
        [GET_ACCEPT_TERMS.ENDED]: false,
        [LOAD_PROJECTS.ENDED]: false,
        [LIST_USER_DETAILS.ENDED]: false,
        [LOAD_ATTRIBUTE_DEFINITIONS.ENDED]: false,
        [LOAD_GLOSSARY.ENDED]: false
    },
    error: null
};

export const startupReducer = produce((draft, action) => {
    switch (action.type) {
        case GET_PUBLIC_CONFIG.ENDED:
        case GET_ACCEPT_TERMS.ENDED:
        case LOAD_PROJECTS.ENDED:
        case LIST_USER_DETAILS.ENDED:
        case LOAD_ATTRIBUTE_DEFINITIONS.ENDED:
        case LOAD_GLOSSARY.ENDED:
            draft.initEvents[action.type] = true;
            break;
        case KEYCLOAK_CONNECTION_ERROR:
            draft.error = {
                title: 'components:StartUp.errors.keycloak.title',
                message: 'components:StartUp.errors.keycloak.message'
            };
            break;
        default:
            break;
    }
}, INITIAL_STATE);
